"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrizePoolNotificationMetadataToJSON = exports.PrizePoolNotificationMetadataFromJSONTyped = exports.PrizePoolNotificationMetadataFromJSON = void 0;
var _1 = require("./");
function PrizePoolNotificationMetadataFromJSON(json) {
    return PrizePoolNotificationMetadataFromJSONTyped(json, false);
}
exports.PrizePoolNotificationMetadataFromJSON = PrizePoolNotificationMetadataFromJSON;
function PrizePoolNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'winnerMessage': json['winnerMessage'],
        'challengeName': json['challengeName'],
        'rewardName': json['rewardName'],
        'assetId': json['assetId'],
        'challengeEndDate': json['challengeEndDate'],
        'notificationType': (0, _1.NotificationTypeFromJSON)(json['notificationType']),
    };
}
exports.PrizePoolNotificationMetadataFromJSONTyped = PrizePoolNotificationMetadataFromJSONTyped;
function PrizePoolNotificationMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'winnerMessage': value.winnerMessage,
        'challengeName': value.challengeName,
        'rewardName': value.rewardName,
        'assetId': value.assetId,
        'challengeEndDate': value.challengeEndDate,
        'notificationType': (0, _1.NotificationTypeToJSON)(value.notificationType),
    };
}
exports.PrizePoolNotificationMetadataToJSON = PrizePoolNotificationMetadataToJSON;
